// extracted by mini-css-extract-plugin
export var fadeInOut = "_4r-3";
export var icon = "_4r-4";
export var savedIndicator = "_4r-2";
export var savingIndicator = "_4r-0";
export var spin = "_4r-1";